/* eslint-disable */
import React from "react";
import {
  FormControl,
  Select,
  MenuItem,
  Box,
  RadioGroup,
  Radio,
  Typography,
  Divider,
  ListItemText,
  Chip,
  Checkbox,
} from "@mui/material";

const FilterDropdown = ({
  isFollowingChecked,
  handleFollowingChange,
  selectedStatus,
  handleStatusChange,
}) => {
  const renderValue = () => {
    if (!isFollowingChecked && selectedStatus === "all") {
      return (
        <Box sx={{ width: "240px", textAlign: "left", fontSize: "14px" }}>
          All golfers
        </Box>
      );
    }

    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          width: "240px",
          minHeight: "24px",
        }}
      >
        {isFollowingChecked && (
          <Chip
            label="Following"
            size="small"
            sx={{
              backgroundColor: "#F3F4F6",
              color: "#475467",
              fontWeight: 500,
              height: "24px",
              fontSize: "14px",
            }}
          />
        )}
        {selectedStatus !== "all" && (
          <Chip
            label={selectedStatus === "qualified" ? "Qualified" : "In-progress"}
            size="small"
            sx={{
              backgroundColor: "#F3F4F6",
              color: "#475467",
              fontWeight: 500,
              height: "24px",
              fontSize: "14px",
            }}
          />
        )}
      </Box>
    );
  };

  return (
    <div className="filter-row">
      <div className="filter-container">
        <Typography variant="body1" sx={{ mr: 1, fontSize: "14px" }}>
          Filter by
        </Typography>
        <FormControl variant="outlined" size="small">
          <Select
            displayEmpty
            value=""
            renderValue={renderValue}
            sx={{
              width: "245px",
              "& .MuiSelect-select": {
                display: "flex",
                alignItems: "center",
                minHeight: "24px",
                fontSize: "14px",
                padding: "6px 14px",
              },
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  width: "200px",
                  borderRadius: "10px 10px 0 0",
                  mt: 1,
                },
              },
            }}
          >
            <MenuItem
              onClick={(e) => {
                handleFollowingChange(!isFollowingChecked);
              }}
              sx={{
                py: 0.5,
                "&:hover": {
                  backgroundColor: "transparent",
                },
              }}
            >
              <Checkbox
                checked={isFollowingChecked}
                sx={{
                  color: "#D0D5DD",
                  "&.Mui-checked": {
                    color: "#2E90FA",
                  },
                }}
              />
              <ListItemText
                primary="Following"
                primaryTypographyProps={{ fontSize: "14px" }}
              />
            </MenuItem>

            <Divider sx={{ my: 0.5 }} />

            <Box
              sx={{
                px: 3,
                py: 1,
                fontWeight: 500,
                fontSize: "14px",
              }}
            >
              By Status
            </Box>

            <RadioGroup
              value={selectedStatus}
              onChange={(e) => handleStatusChange(e.target.value)}
            >
              <MenuItem
                onClick={() => handleStatusChange("all")}
                sx={{ py: 0.5 }}
              >
                <Radio
                  value="all"
                  checked={selectedStatus === "all"}
                  sx={{
                    color: "#D0D5DD",
                    "&.Mui-checked": {
                      color: "#2E90FA",
                    },
                  }}
                />
                <ListItemText
                  primary="All"
                  primaryTypographyProps={{ fontSize: "14px" }}
                />
              </MenuItem>

              <MenuItem
                onClick={() => handleStatusChange("qualified")}
                sx={{ py: 0.5 }}
              >
                <Radio
                  value="qualified"
                  checked={selectedStatus === "qualified"}
                  sx={{
                    color: "#D0D5DD",
                    "&.Mui-checked": {
                      color: "#2E90FA",
                    },
                  }}
                />
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <Typography variant="body1" sx={{ fontSize: "14px" }}>
                    Qualified
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ fontSize: "14px" }}
                  >
                    Posted 3+ rounds
                  </Typography>
                </Box>
              </MenuItem>

              <MenuItem
                onClick={() => handleStatusChange("in_progress")}
                sx={{ py: 0.5 }}
              >
                <Radio
                  value="in_progress"
                  checked={selectedStatus === "in_progress"}
                  sx={{
                    color: "#D0D5DD",
                    "&.Mui-checked": {
                      color: "#2E90FA",
                    },
                  }}
                />
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <Typography variant="body1" sx={{ fontSize: "14px" }}>
                    In-progress
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ fontSize: "14px" }}
                  >
                    Posted less than 3 rounds
                  </Typography>
                </Box>
              </MenuItem>
            </RadioGroup>
          </Select>
        </FormControl>
      </div>
    </div>
  );
};

export default FilterDropdown;
